import * as angular from "angular";
/* tslint:disable:no-string-literal */
window["ngRoute"] = "ngRoute"; // To map angular-route via Webpack externals
window["ngAria"] = "ngAria"; // To map angular-aria via Webpack externals
window["ngCookies"] = "ngCookies"; // To use cookies for modal

import "angular-route";
import "angular-aria";
import "angulartics";
import "angulartics-google-analytics";
import "angular-cookies";

import {initRoutes} from "./app-routes/app.routes";
import {initComponents} from "./app.components";
import "@naviance/common-angular-components";
import {initServices} from "./app.services";
import {initConfig} from "./app.config";
import {initRun} from "./app-run/app.run";

require("./app.scss");

const app = angular.module("App", [
    "ngRoute",
    "ngAria",
    "angulartics",
    "angulartics.google.analytics",
    "ngCookies",
    "commonAngularComponents"
]);

// Initialize Angular constants based on app-config.json
// CONFIG is injected at compile-time by webpack.DefinePlugin
declare const CONFIG: Object;
Object.keys(CONFIG).forEach(key => app.constant(key, CONFIG[key]));

initRoutes(app);
initComponents(app);
initServices(app);
initConfig(app);
initRun(app);

export default app;
export const ng = angular;



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/app.ts
 **/